const segment = (value, fallback) => {
  const normalized = String(value || "").trim();
  return encodeURIComponent(normalized || fallback);
};

export function buildPageBuilderDraftStorageKeys({ userId, pageId, pageMode } = {}) {
  const scope = [
    "pb_autosave_v2",
    segment(userId, "anonymous"),
    segment(pageId, `new-${String(pageMode || "static")}`),
  ].join(":");
  return {
    draftKey: `${scope}:draft`,
    metaKey: `${scope}:meta`,
  };
}
